import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import { Box, IconButton, Paper, Typography } from "@mui/material";
import React, { useState } from "react";

// ── Types ─────────────────────────────────────────────────────────────────────

interface ProgressSubRow {
  resolutionStatus: string;
  workedAmountYesterday?: number | null;
  workedAmountPast7?: number | null;
  workedAmountPast15?: number | null;
  workedCountYesterday?: number | null;
  workedCountPast7?: number | null;
  workedCountPast15?: number | null;
  resolvedAmountYesterday?: number | null;
  resolvedAmountPast7?: number | null;
  resolvedAmountPast15?: number | null;
  resolvedAmountTotalNet?: number | null;
  resolvedCountYesterday?: number | null;
  resolvedCountPast7?: number | null;
  resolvedCountPast15?: number | null;
  resolvedCountTotalNet?: number | null;
}

interface ProgressDeptRow extends ProgressSubRow {
  subRows?: ProgressSubRow[];
}

interface ProgressRow {
  department: string;
  allStatusRow: ProgressDeptRow;
}

// ── Static data ───────────────────────────────────────────────────────────────

const STATIC_DATA: ProgressRow[] = [
  {
    department: "Warehouse",
    allStatusRow: {
      resolutionStatus: "All statuses",
      workedAmountYesterday: 0,
      workedAmountPast7: 68906,
      workedAmountPast15: 68906,
      workedCountYesterday: 0,
      workedCountPast7: 1,
      workedCountPast15: 1,
      resolvedAmountYesterday: 0,
      resolvedAmountPast7: 0,
      resolvedAmountPast15: 0,
      resolvedAmountTotalNet: 0,
      resolvedCountYesterday: 0,
      resolvedCountPast7: 0,
      resolvedCountPast15: 0,
      resolvedCountTotalNet: 0,
      subRows: [
        {
          resolutionStatus: "Leadership Approval Required",
          workedAmountYesterday: 0,
          workedAmountPast7: 0,
          workedAmountPast15: 0,
          workedCountYesterday: 0,
          workedCountPast7: 0,
          workedCountPast15: 0,
          resolvedAmountYesterday: 0,
          resolvedAmountPast7: 0,
          resolvedAmountPast15: 0,
          resolvedAmountTotalNet: 0,
          resolvedCountYesterday: 0,
          resolvedCountPast7: 0,
          resolvedCountPast15: 0,
          resolvedCountTotalNet: 0,
        },
        {
          resolutionStatus: "Clarification Pending",
          workedAmountYesterday: 0,
          workedAmountPast7: 68906,
          workedAmountPast15: 68906,
          workedCountYesterday: 0,
          workedCountPast7: 1,
          workedCountPast15: 1,
          resolvedAmountYesterday: 0,
          resolvedAmountPast7: 0,
          resolvedAmountPast15: 0,
          resolvedAmountTotalNet: 0,
          resolvedCountYesterday: 0,
          resolvedCountPast7: 0,
          resolvedCountPast15: 0,
          resolvedCountTotalNet: 0,
        },
        {
          resolutionStatus: "Docs Pending",
          workedAmountYesterday: 0,
          workedAmountPast7: 0,
          workedAmountPast15: 0,
          workedCountYesterday: 0,
          workedCountPast7: 0,
          workedCountPast15: 0,
          resolvedAmountYesterday: 0,
          resolvedAmountPast7: 0,
          resolvedAmountPast15: 0,
          resolvedAmountTotalNet: 0,
          resolvedCountYesterday: 0,
          resolvedCountPast7: 0,
          resolvedCountPast15: 0,
          resolvedCountTotalNet: 0,
        },
      ],
    },
  },
  {
    department: "Procurement",
    allStatusRow: {
      resolutionStatus: "All statuses",
      workedAmountYesterday: 0,
      workedAmountPast7: 0,
      workedAmountPast15: 0,
      workedCountYesterday: 0,
      workedCountPast7: 0,
      workedCountPast15: 0,
      resolvedAmountYesterday: 0,
      resolvedAmountPast7: 0,
      resolvedAmountPast15: 0,
      resolvedAmountTotalNet: 0,
      resolvedCountYesterday: 0,
      resolvedCountPast7: 0,
      resolvedCountPast15: 0,
      resolvedCountTotalNet: 0,
      subRows: [
        {
          resolutionStatus: "Require Confirmation",
          workedAmountYesterday: 0,
          workedAmountPast7: 0,
          workedAmountPast15: 0,
          workedCountYesterday: 0,
          workedCountPast7: 0,
          workedCountPast15: 0,
          resolvedAmountYesterday: 0,
          resolvedAmountPast7: 0,
          resolvedAmountPast15: 0,
          resolvedAmountTotalNet: 0,
          resolvedCountYesterday: 0,
          resolvedCountPast7: 0,
          resolvedCountPast15: 0,
          resolvedCountTotalNet: 0,
        },
      ],
    },
  },
  {
    department: "Finance",
    allStatusRow: {
      resolutionStatus: "All statuses",
      workedAmountYesterday: 0,
      workedAmountPast7: 998034,
      workedAmountPast15: 11421597,
      workedCountYesterday: 0,
      workedCountPast7: 12,
      workedCountPast15: 114,
      resolvedAmountYesterday: 0,
      resolvedAmountPast7: 224568,
      resolvedAmountPast15: 2772863,
      resolvedAmountTotalNet: 2772863,
      resolvedCountYesterday: 0,
      resolvedCountPast7: 2,
      resolvedCountPast15: 25,
      resolvedCountTotalNet: 25,
      subRows: [
        {
          resolutionStatus: "Approved for Booking",
          workedAmountYesterday: 0,
          workedAmountPast7: 0,
          workedAmountPast15: 0,
          workedCountYesterday: 0,
          workedCountPast7: 0,
          workedCountPast15: 0,
          resolvedAmountYesterday: 0,
          resolvedAmountPast7: 0,
          resolvedAmountPast15: 0,
          resolvedAmountTotalNet: 0,
          resolvedCountYesterday: 0,
          resolvedCountPast7: 0,
          resolvedCountPast15: 0,
          resolvedCountTotalNet: 0,
        },
        {
          resolutionStatus: "Review Pending",
          workedAmountYesterday: 0,
          workedAmountPast7: 998034,
          workedAmountPast15: 11421597,
          workedCountYesterday: 0,
          workedCountPast7: 12,
          workedCountPast15: 114,
          resolvedAmountYesterday: 0,
          resolvedAmountPast7: 224568,
          resolvedAmountPast15: 2772863,
          resolvedAmountTotalNet: 2772863,
          resolvedCountYesterday: 0,
          resolvedCountPast7: 2,
          resolvedCountPast15: 25,
          resolvedCountTotalNet: 25,
        },
        {
          resolutionStatus: "Docs Pending",
          workedAmountYesterday: 0,
          workedAmountPast7: 0,
          workedAmountPast15: 0,
          workedCountYesterday: 0,
          workedCountPast7: 0,
          workedCountPast15: 0,
          resolvedAmountYesterday: 0,
          resolvedAmountPast7: 0,
          resolvedAmountPast15: 0,
          resolvedAmountTotalNet: 0,
          resolvedCountYesterday: 0,
          resolvedCountPast7: 0,
          resolvedCountPast15: 0,
          resolvedCountTotalNet: 0,
        },
      ],
    },
  },
  {
    department: "Vendor",
    allStatusRow: {
      resolutionStatus: "All statuses",
      workedAmountYesterday: 0,
      workedAmountPast7: 0,
      workedAmountPast15: 0,
      workedCountYesterday: 0,
      workedCountPast7: 0,
      workedCountPast15: 0,
      resolvedAmountYesterday: 0,
      resolvedAmountPast7: 0,
      resolvedAmountPast15: 0,
      resolvedAmountTotalNet: 0,
      resolvedCountYesterday: 0,
      resolvedCountPast7: 0,
      resolvedCountPast15: 0,
      resolvedCountTotalNet: 0,
      subRows: [
        {
          resolutionStatus: "Booking Pending",
          workedAmountYesterday: 0,
          workedAmountPast7: 0,
          workedAmountPast15: 0,
          workedCountYesterday: 0,
          workedCountPast7: 0,
          workedCountPast15: 0,
          resolvedAmountYesterday: 0,
          resolvedAmountPast7: 0,
          resolvedAmountPast15: 0,
          resolvedAmountTotalNet: 0,
          resolvedCountYesterday: 0,
          resolvedCountPast7: 0,
          resolvedCountPast15: 0,
          resolvedCountTotalNet: 0,
        },
        {
          resolutionStatus: "Docs Pending",
          workedAmountYesterday: 0,
          workedAmountPast7: 0,
          workedAmountPast15: 0,
          workedCountYesterday: 0,
          workedCountPast7: 0,
          workedCountPast15: 0,
          resolvedAmountYesterday: 0,
          resolvedAmountPast7: 0,
          resolvedAmountPast15: 0,
          resolvedAmountTotalNet: 0,
          resolvedCountYesterday: 0,
          resolvedCountPast7: 0,
          resolvedCountPast15: 0,
          resolvedCountTotalNet: 0,
        },
      ],
    },
  },
];

// ── Styles ────────────────────────────────────────────────────────────────────

const BORDER = "1px solid #e0e0e0";
const DEPT_BG = "#fafafa";

const getDeptColor = (dept: string): string => {
  const d = dept.toLowerCase();
  if (d.includes("vendor")) return "#ffcc80";
  if (d.includes("finance")) return "#ffab91";
  if (d.includes("warehouse")) return "#81d4fa";
  if (d.includes("procurement")) return "#a5d6a7";
  return "#e0e0e0";
};

const thBase: React.CSSProperties = {
  fontFamily: "Inter",
  fontSize: 12,
  fontWeight: 600,
  color: "rgba(0,0,0,0.87)",
  padding: "0 16px",
  height: "51px",
  borderBottom: BORDER,
  borderRight: BORDER,
  whiteSpace: "nowrap",
  textAlign: "center",
  verticalAlign: "middle",
  letterSpacing: "0.012px",
  backgroundColor: DEPT_BG,
};

const tdBase: React.CSSProperties = {
  fontFamily: "Inter",
  fontSize: 12,
  color: "rgba(0,0,0,0.87)",
  padding: "0 16px",
  height: "51px",
  borderBottom: BORDER,
  borderRight: BORDER,
  whiteSpace: "nowrap",
  textAlign: "center",
  verticalAlign: "middle",
  letterSpacing: "0.1176px",
};

const fmt = (val?: number | null): string => (val === null || val === undefined ? "-" : val.toLocaleString("en-IN"));

const DataCells: React.FC<{ row: ProgressSubRow }> = ({ row }) => (
  <>
    <td style={{ ...tdBase }}>{fmt(row.workedAmountYesterday)}</td>
    <td style={{ ...tdBase }}>{fmt(row.workedAmountPast7)}</td>
    <td style={{ ...tdBase }}>{fmt(row.workedAmountPast15)}</td>
    <td style={{ ...tdBase }}>{fmt(row.workedCountYesterday)}</td>
    <td style={{ ...tdBase }}>{fmt(row.workedCountPast7)}</td>
    <td style={{ ...tdBase }}>{fmt(row.workedCountPast15)}</td>
    <td style={{ ...tdBase }}>{fmt(row.resolvedAmountYesterday)}</td>
    <td style={{ ...tdBase }}>{fmt(row.resolvedAmountPast7)}</td>
    <td style={{ ...tdBase }}>{fmt(row.resolvedAmountPast15)}</td>
    <td style={{ ...tdBase }}>{fmt(row.resolvedAmountTotalNet)}</td>
    <td style={{ ...tdBase }}>{fmt(row.resolvedCountYesterday)}</td>
    <td style={{ ...tdBase }}>{fmt(row.resolvedCountPast7)}</td>
    <td style={{ ...tdBase }}>{fmt(row.resolvedCountPast15)}</td>
    <td style={{ ...tdBase }}>{fmt(row.resolvedCountTotalNet)}</td>
  </>
);

const NonReconProgressTable: React.FC = () => {
  const [expandedDepts, setExpandedDepts] = useState<Set<string>>(new Set());

  const toggle = (dept: string) => {
    setExpandedDepts((prev) => {
      const next = new Set(prev);
      if (next.has(dept)) next.delete(dept);
      else next.add(dept);
      return next;
    });
  };

  return (
    <Paper
      sx={{
        backgroundColor: "#ffffff",
        borderRadius: "8px",
        boxShadow:
          "0px 1px 3px 0px rgba(0,0,0,0.12), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 2px 1px -1px rgba(0,0,0,0.2)",
        overflow: "hidden",
        margin: "16px 0",
      }}
    >
      <Box sx={{ p: 2 }}>
        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "16px" }}>
          <Typography
            sx={{
              fontFamily: "Inter",
              fontWeight: 600,
              fontSize: "16px",
              color: "rgba(0,0,0,0.87)",
              letterSpacing: "0.024px",
            }}
          >
            Department-wise Progress Summary
          </Typography>
        </Box>

        <Box sx={{ border: "1px solid rgba(0,0,0,0.01)", borderRadius: "8px", overflow: "hidden" }}>
          <Box sx={{ overflowX: "auto" }}>
            <table style={{ borderCollapse: "collapse", width: "100%", tableLayout: "auto" }}>
              <thead>
                <tr>
                  <th style={{ ...thBase, minWidth: 110 }} rowSpan={2}>
                    Department
                  </th>
                  <th style={{ ...thBase, minWidth: 220 }} rowSpan={2}>
                    Resolution Status
                  </th>
                  <th style={{ ...thBase }} colSpan={3}>
                    Total Worked On (Amount)
                  </th>
                  <th style={{ ...thBase }} colSpan={3}>
                    Total Worked On (Count)
                  </th>
                  <th style={{ ...thBase }} colSpan={4}>
                    Total Resolved Cases (Amount)
                  </th>
                  <th style={{ ...thBase }} colSpan={4}>
                    Total Resolved Cases (Count)
                  </th>
                </tr>
                <tr>
                  <th style={{ ...thBase, minWidth: 85 }}>Yesterday</th>
                  <th style={{ ...thBase, minWidth: 85 }}>Past 7 days</th>
                  <th style={{ ...thBase, minWidth: 90 }}>Past 15 days</th>
                  <th style={{ ...thBase, minWidth: 85 }}>Yesterday</th>
                  <th style={{ ...thBase, minWidth: 85 }}>Past 7 days</th>
                  <th style={{ ...thBase, minWidth: 90 }}>Past 15 days</th>
                  <th style={{ ...thBase, minWidth: 85 }}>Yesterday</th>
                  <th style={{ ...thBase, minWidth: 85 }}>Past 7 days</th>
                  <th style={{ ...thBase, minWidth: 90 }}>Past 15 days</th>
                  <th style={{ ...thBase, minWidth: 80 }}>Total Net</th>
                  <th style={{ ...thBase, minWidth: 85 }}>Yesterday</th>
                  <th style={{ ...thBase, minWidth: 85 }}>Past 7 days</th>
                  <th style={{ ...thBase, minWidth: 90 }}>Past 15 days</th>
                  <th style={{ ...thBase, minWidth: 80 }}>Total Net</th>
                </tr>
              </thead>

              <tbody>
                {STATIC_DATA.map((dept) => {
                  const isExpanded = expandedDepts.has(dept.department);
                  const subRows = dept.allStatusRow.subRows ?? [];
                  const deptRowSpan = isExpanded ? 1 + subRows.length : 1;

                  return (
                    <React.Fragment key={dept.department}>
                      {/* All statuses row */}
                      <tr style={{ backgroundColor: "#ffffff" }}>
                        <td
                          rowSpan={deptRowSpan}
                          style={{
                            ...tdBase,
                            backgroundColor: DEPT_BG,
                            fontWeight: 600,
                            verticalAlign: "middle",
                            borderLeft: `8px solid ${getDeptColor(dept.department)}`,
                          }}
                        >
                          {dept.department}
                        </td>
                        <td
                          style={{ ...tdBase, cursor: "pointer", userSelect: "none" }}
                          onClick={() => toggle(dept.department)}
                        >
                          <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                            <IconButton
                              size="small"
                              sx={{ p: 0.25, color: "rgba(0,0,0,0.6)" }}
                              onClick={(e) => {
                                e.stopPropagation();
                                toggle(dept.department);
                              }}
                            >
                              {isExpanded ? (
                                <KeyboardArrowDownIcon sx={{ fontSize: 16 }} />
                              ) : (
                                <KeyboardArrowRightIcon sx={{ fontSize: 16 }} />
                              )}
                            </IconButton>
                            <span style={{ fontWeight: 600, fontSize: 12 }}>All statuses</span>
                          </Box>
                        </td>
                        <DataCells row={dept.allStatusRow} />
                      </tr>

                      {/* Sub-rows */}
                      {isExpanded &&
                        subRows.map((sub, sIdx) => (
                          <tr key={`${dept.department}-${sIdx}`} style={{ backgroundColor: "#ffffff" }}>
                            <td style={{ ...tdBase, paddingLeft: 60 }}>{sub.resolutionStatus}</td>
                            <DataCells row={sub} />
                          </tr>
                        ))}
                    </React.Fragment>
                  );
                })}
              </tbody>
            </table>
          </Box>
        </Box>
      </Box>
    </Paper>
  );
};

export default NonReconProgressTable;
